import React, { useEffect, useState } from "react";
import { HashRouter as Router, Route, Routes, useParams, useNavigate } from "react-router-dom";
import StandPage from "./pages/StandPage";
import MapPage from "./pages/MapPage";
import Loading from "./components/Loading";
import decryptPath from "./utils/decryptionService";

const EncryptedRedirect = () => {
  const { encryptedPath } = useParams();
  const navigate = useNavigate();
  const [decryptedData, setDecryptedData] = useState(null);

  useEffect(() => {
    decryptPath(encryptedPath)
      .then((data) => {
        setDecryptedData(data);
      })
      .catch((err) => {
        console.error("Decryption failed:", err);
        navigate("/", { replace: true });
      });
  }, [encryptedPath, navigate]);

  if (!decryptedData) {
    return <Loading />;
  }

  return <StandPage encryptedData={decryptedData} />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/:encryptedPath" element={<EncryptedRedirect />} />
        <Route path="/:ExCode/:PavCode/:standCode" element={<StandPage />} />
        <Route path="/:ExCode/:PavCode/map" element={<MapPage />} />
      </Routes>
    </Router>
  );
}

export default App;